import { render, staticRenderFns } from "./CoAPreview.vue?vue&type=template&id=35b3167a&scoped=true"
import script from "./CoAPreview.vue?vue&type=script&lang=js"
export * from "./CoAPreview.vue?vue&type=script&lang=js"
import style0 from "./CoAPreview.vue?vue&type=style&index=0&id=35b3167a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b3167a",
  null
  
)

export default component.exports